import { api } from './client';

export interface TargetRow {
  channel: string;
  person: string;
  spend: number;
  impressions: number;
  reach: number;
  frequency: number;
  clicks: number;
  // all numeric fields are float64 from backend
  add_to_cart: number;
  purchases: number;
  revenue: number;
  registrations: number;
  cpm: number;
  ctr: number;
  cpc: number;
  add_to_cart_cost: number;
  cpa: number;
  roi: number;
  aov: number;
  add_to_cart_rate: number;
  cart_conversion_rate: number;
  purchase_rate: number;
}

export interface TargetTrackingParams {
  brand_id: string;
  site_id?: string;
  period_type: string;
  period_start: string;
}

export const targetTrackingApi = {
  getData: (params: TargetTrackingParams) =>
    api.get<{ code: number; data: TargetRow[] }>('/target-tracking/data', { params }),
};
